import React from 'react';
import { AllEvents,VideoPerformances } from '../components';
import './pages.css';

const EventsPage = () => {
  return (
    <div className="page page--events">
      <section className="page__hero page__hero--events page__hero--compact page__hero--events-compact">
        <div className="page__hero-content">
          <h1 className="gradient__text page__hero-title">Our Events</h1>
          <p className="page__hero-subtitle">Celebrating performances, milestones, and cultural excellence</p>
        </div>
      </section>

      <div className="section__padding">
        <AllEvents />
        <VideoPerformances />
      </div>
    </div>
  );
};

export default EventsPage;
